import token from '../utils/token'
import Signature from '../utils/signature'
import axios from 'axios'

// console.log(__wxConfig)
// const PLATFORM = __wxConfig.platform
const BASE_URL = () => {
    // console.log(token.getToken('test'))
    return window.location.host == 'clause.zuber.im'
    ? 'https://66miniapp-api.66zhizu.com/client'
    : 'https://66miniapp.zuker.im/client'
}

const signature = new Signature(token, 'client')

const handler = res => {
    // console.log(res)
    if (res.status === 200) {
        switch (res.data.code) {
            case 0:
                return res.data.result ? res.data.result : Promise.reject(res.data.msg)
            case 23401:
                return Promise.reject(res.data.code)
            case 401:
                token.cleanToken()
                window.location.reload()
                return Promise.reject(res.data.msg)
            case 10109: 
                token.cleanToken()
                window.location.reload()
                return Promise.reject(res.data.msg)
            default:
                // wx.showModal({
                //     title: '提示',
                //     content: res.data.msg,
                //     showCancel: false,
                //     confirmText: '知道了',
                //     success: () => {
                //         wx.hideLoading()
                //     }
                // })
                return Promise.reject(res.data.msg)
        }
    }
}

export default {
    resource (route) {
        let _resource = axios.create({
            baseURL: BASE_URL() + route
        })
        // authentication
        _resource.interceptors.request.use(config => {
            config.headers.Authorization = signature.generate(route + config.url, config.method, config.data)
            return config
        }, error => {
            return Promise.reject(error)
        })
        // handle reponse
        _resource.interceptors.response.use(res => {
            return handler(res)
        }, error => {
            return Promise.reject(error)
        })
        return _resource;
    }
}